import { useState } from 'react';
import Modal from '../../components/common/Modal';

export default function SecaoForm({ onClose, onSalvar }) {
  const [numero, setNumero] = useState('');
  const [nome, setNome] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await onSalvar({ numero, nome });
      onClose();
    } catch (err) {
      setErro(err?.response?.data?.detail || 'Não foi possível salvar.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Modal titulo="Nova seção" onClose={onClose}>
      <form className="am-form" onSubmit={handleSubmit}>
        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">Número</span>
          </div>
          <input value={numero} onChange={(e) => setNumero(e.target.value)} placeholder="5" required />
        </label>
        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">Nome</span>
          </div>
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome da seção" required />
        </label>
        {erro && <div className="am-field__error">{erro}</div>}
        <div className="am-form__actions">
          <button type="button" className="am-btn am-btn-outline" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="am-btn am-btn-dark" disabled={enviando}>
            {enviando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
